import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { CustomAxios } from '../../../../redux/axios';
import {
  selectCurrentLocationId,
  selectCurrentLocationParentId,
} from '../../../../redux/actions/location';
import { selectCurrentLocationV2 } from '../../../../redux/actions/location/locations/locationsV2.selectors';

export interface SchedulingFeatureReadiness {
  name: string;
  enabled: boolean;
  classification: string;
  summary: string;
  reasonCodes: string[];
  recommendationCode: string;
  message: string;
  active: boolean;
  evaluatedAt: string;
}

export interface SchedulingFeaturesReadyResponse {
  orgId: string;
  scope: string;
  parentLocationId: string;
  features: SchedulingFeatureReadiness[];
}

export const useSchedulingFeaturesReady = () => {
  const locationId = useSelector(selectCurrentLocationId);
  const parentLocationId = useSelector(selectCurrentLocationParentId);
  const orgId = useSelector(selectCurrentLocationV2)?.orgId ?? '';
  // A location without a parent is its own (single-location) group.
  const locationGroupId = parentLocationId || locationId;

  const query = useQuery(
    ['schedule', 'settings-ready', orgId, locationGroupId],
    async () => {
      const response = await CustomAxios.get<SchedulingFeaturesReadyResponse>(
        `/schedule/v3/settings/ready/${orgId}/location-groups/${locationGroupId}`
      );
      return response.data;
    },
    { enabled: !!orgId && !!locationGroupId }
  );

  return { ...query, orgId, locationGroupId };
};
